import i18n from 'modules/core/lib/i18n'

const LEAVE_TYPE_TEXTS: Record<string, () => string> = {
  caring_dependents: () => i18n.t('settings.leave_types.defaults.caring_dependents'),
  compassionate: () => i18n.t('settings.leave_types.defaults.compassionate'),
  congress: () => i18n.t('settings.leave_types.defaults.congress'),
  custom: () => i18n.t('settings.leave_types.defaults.custom'),
  doctors_appointment: () => i18n.t('settings.leave_types.defaults.doctors_appointment'),
  exams: () => i18n.t('settings.leave_types.defaults.exams'),
  family_day: () => i18n.t('settings.leave_types.defaults.family_day'),
  family_illness: () => i18n.t('settings.leave_types.defaults.family_illness'),
  generic: () => i18n.t('settings.leave_types.defaults.generic'),
  holiday: () => i18n.t('settings.leave_types.defaults.holiday'),
  jury_duty: () => i18n.t('settings.leave_types.defaults.jury_duty'),
  marriage: () => i18n.t('settings.leave_types.defaults.marriage'),
  maternity: () => i18n.t('settings.leave_types.defaults.maternity'),
  medical_leave: () => i18n.t('settings.leave_types.defaults.medical_leave'),
  military_service: () => i18n.t('settings.leave_types.defaults.military_service'),
  moving_house: () => i18n.t('settings.leave_types.defaults.moving_house'),
  other: () => i18n.t('settings.leave_types.defaults.other'),
  overtime_compensation: () => i18n.t('settings.leave_types.defaults.overtime_compensation'),
  paid_unspecified_leave: () => i18n.t('settings.leave_types.defaults.paid_unspecified_leave'),
  parental: () => i18n.t('settings.leave_types.defaults.parental'),
  paternity: () => i18n.t('settings.leave_types.defaults.paternity'),
  personal_day: () => i18n.t('settings.leave_types.defaults.personal_day'),
  sabbatical: () => i18n.t('settings.leave_types.defaults.sabbatical'),
  sick: () => i18n.t('settings.leave_types.defaults.sick'),
  study_day: () => i18n.t('settings.leave_types.defaults.study_day'),
  training: () => i18n.t('settings.leave_types.defaults.training'),
  unpaid_unspecified_leave: () => i18n.t('settings.leave_types.defaults.unpaid_unspecified_leave'),
  wfh: () => i18n.t('settings.leave_types.defaults.wfh'),
  work_travel: () => i18n.t('settings.leave_types.defaults.work_travel'),
}

export const getTimeoffDefaultsLabel = (type: string) => {
  if (!(type in LEAVE_TYPE_TEXTS)) {
    throw new Error(`Unknown translation for type: ${type}`)
  }

  return LEAVE_TYPE_TEXTS[type]?.() ?? ''
}

const APPROVAL_SUGGESTION_TEXTS: Record<string, () => string> = {
  approve: () => i18n.t('time_off.approval_recommendation.approval_suggested'),
  reject: () => i18n.t('time_off.approval_recommendation.reject_recommended'),
  review: () => i18n.t('time_off.approval_recommendation.review_needed'),
  no_recommendation: () => i18n.t('time_off.approval_recommendation.no_recommendation'),
}

export const getApprovalSuggestionKey = (suggestion: string): string => {
  return APPROVAL_SUGGESTION_TEXTS[suggestion]?.() ?? ''
}
